import { API_URL } from './config';

export const sendReceipt = async (orderId: string, type: 'success' | 'unsuccess') => {
  try {
    const response = await fetch(`${API_URL}/sendReceipt/${orderId}?type=${type}`, {
      method: 'POST',
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
  }
};
